import React from 'react';
import Hero from './components/nss/Hero';
import Main from './components/nss/Main';

const Nss = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default Nss;